import React, { useContext, useEffect, useRef, useState } from 'react'
import { useTranslation } from "react-i18next";
import info from '../../../../Images/Restaurant/info.png'
import { userContext } from "../../../../context/userContext";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { environmentVariables } from '../../../../config/env.config';
import { getAvailableSlots, getcoutryfromlocation, getCurrencyData } from '../../../../utils/utility';
import CircularLoader from '../../../Components/CircularLoader/CircularLoader';
import PhoneInput from 'react-phone-input-2';
import { toast, ToastContainer } from 'react-toastify';
import { isValidPhoneNumberAppoitment } from "../../../Components/AppointmentValidation";
import { useFormik } from "formik";
import axios from "axios";
import moment from "moment";
export const BusinessSchedule = ({ props, ext, handleActive }) => {

  let data = props?.rs || props;
  const { t } = useTranslation();
  const baseUrl = environmentVariables?.apiUrl;
  // console.log(data, '//////', props, '////////////////////')
  const [selectedDate, setSelectedDate] = useState();
  const [appointmentData, setAppointmentData] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [activeTime, setActiveTime] = useState(null);
  const [appointmentTime, setAppointmentTime] = useState(null);
  const [errorMsgName, setErrorMsgName] = useState("");
  const [errorMsgEmail, setErrorMsgEmail] = useState("");
  const [errorMsgNo, setErrorMsgNo] = useState("");
  const [errorMsgText, setErrorMsgText] = useState("");
  const [appointmentName, setAppointmentName] = useState("");
  const [appointmentEmail, setAppointmentEmail] = useState("");
  const [appointmentContactNumber, setAppointmentContactNumber] = useState("+971-" || "");
  const [appointmentCountryCode, setAppointmentCountryCode] = useState("uae");
  const [isSubmitAppointment, setIsSubmitAppointment] = useState(false);
  const createUserRef = useRef(null);
  const calendarInputRef = useRef(null);
  const { userData } = useContext(userContext);
  // const currencyForCustomPay =  getCurrencyData(data?.shipCountry)


  const today = new Date();
  const days = ["Sun,", "Mon,", "Tue,", "Wed,", "Thur,", "Fri,", "Sat,"];


  const nextSixDays = Array.from({ length: 6 }, (_, i) => {
    const date = new Date(today);

    date.setDate(today.getDate() + i);
    return {
      day: days[date.getDay()],
      date: date
    };
  });




  useEffect(() => {
    const fetchCountryfromlocation = async () => {
      try {
        const countryData = await getcoutryfromlocation();
        console.log("countryDatacountryData", countryData)
        setAppointmentCountryCode(countryData?.countryCode.toLowerCase());
      } catch (error) {
        console.error("Error fetching country data:", error);
      }
    };
    fetchCountryfromlocation()
  }, []);

  const isValidName = (name) => {
    const nameRegex = /^[\p{L}\p{N}\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF\u064B-\u065F -]+$/u;
    return nameRegex.test(name);
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[A-Za-z0-9._%-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/;
    return emailRegex.test(email);
  };

  const handleChangeAppointmentDate = async(dateVal, index) => {
    let newDate = moment(dateVal).format("YYYY-MM-DD");
    setActiveIndex(index)
    setSelectedDate(dateVal);
    const day = dateVal.toLocaleDateString('en-IN', { weekday: 'long' });
    const formattedDate = dateVal.toISOString();



    // const dateObject = new Date(dateVal);
    // const dayIndex = dateObject.getDay();

    // const daysOfWeek = [
    //   "Sunday",
    //   "Monday",
    //   "Tuesday",
    //   "Wednesday",
    //   "Thursday",
    //   "Friday",
    //   "Saturday",
    // ];

    if (data?.appointmentArray && data?.appointmentArray?.length != 0) {
      let filteredSlots = await getAvailableSlots(data?.appointmentArray[`${day.toLowerCase()}`], newDate);
      setAppointmentData(filteredSlots);
    } else {
      try {
        const parsedContent = ext ? JSON.parse(data?.appointmentObj?.content) : JSON.parse(JSON.parse(data?.businessObj?.appointmentObj?.content));
        let filteredSlots = await getAvailableSlots(parsedContent[`${day.toLowerCase()}`], newDate);

        setAppointmentData(filteredSlots);
      } catch (err) {
        console.log(err);
      }
    }
  };

  const handleChangeAppointmentTime = (time, index) => {
    setActiveTime(index)
    let newTime = `${time?.startDate} - ${time?.endDate}`
    setAppointmentTime(newTime)
  }


  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsgName("");
    setErrorMsgEmail("");
    setErrorMsgNo("");
    setErrorMsgText("");



    if (!appointmentName) {
      setErrorMsgName(t("Name_required"));
      return;
    } else if (!isValidName(appointmentName)) {
      setErrorMsgName(t("Only_alphabets_allowed"));
      return;
    } else if (appointmentName.length < 3) {
      setErrorMsgName(t("Minimum_3_characters_required"))
    }

    if (!appointmentEmail) {
      setErrorMsgEmail(t("Email_required"));
      return;
    } else if (!isValidEmail(appointmentEmail)) {
      setErrorMsgEmail(t("Invalid_email"));
      return;
    }

    if (!appointmentContactNumber) {
      setErrorMsgNo(t("Phone_number_required"));
      return;
    } else if (
      !isValidPhoneNumberAppoitment(
        appointmentContactNumber,
        appointmentCountryCode || "IN"
      )
    ) {
      setErrorMsgNo(t("Invalid_number_for_selected_country"));
      return;
    }

    setIsSubmitAppointment(true);

    let number_last = appointmentContactNumber?.split("-")?.[1];
    let number_first = appointmentContactNumber?.split("-")?.[0];
    try {
      const dateObject = new Date(selectedDate);
      dateObject.setHours(12, 0, 0);
      const response = await axios.post(
        `${baseUrl}api/v1/appointment/MakeAppoinments`,
        {
          business_id: data.id,
          name: appointmentName,
          email: appointmentEmail,
          phone: number_last,
          dialcode: number_first,
          date: dateObject.toISOString(),
          time: appointmentTime,
          status: "pending",
          createdBy: props?.rs?.created_by,
          // note: textareaValue,
        },
        {
          headers: {
            _token: userData?.token,
          },
        }
      );
      if (response?.data?.success) {
        toast.success(t("Appointment_successfull_create"), {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
        setIsSubmitAppointment(false);
        setAppointmentName("");
        setAppointmentEmail("");
        setAppointmentContactNumber("");
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    } catch (error) {


      toast.error(error?.response?.data?.message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      });
      setIsSubmitAppointment(false);
    }
  };



  return (

    <>
      <div className='customSchedule'>
        <article className="makeappitmneets colorback my-0 ">
          <h3
            className="sectitle makeappoint  mb-3"
            style={{ color: props?.dynamicTextHeadingColor || "#123463" }}
          >
            {" "}
            {data?.appointmentsHeading || t("Schedule an Appointment")}
          </h3>
          <div className="contact-form">
            <h2 className="selectDate mb-2">
             {t("Select_date")}
            </h2>
            <div class="col-12 mb-3 " style={{ position: "relative" }}>
              <DatePicker
                selected={selectedDate}
                ref={calendarInputRef}
                minDate={new Date()}
                placeholderText={t("Date")}
                onChange={(date) => handleChangeAppointmentDate(date)}
                className="form-control font-Inter font-medium"
                popperPlacement="bottom-end"
              />
              <div
                className="calanderIcon firefox-hide"
                onClick={() => calendarInputRef.current.setOpen(true)}
              >
                <img
                  src={environmentVariables?.s3UrlDarkCalenderIconDays}
                  alt="Calendar Icon"
                />
              </div>
            </div>
            <div className="grid grid-cols-3 gap-3">
              {nextSixDays.map((item, index) => (
                <button
                  key={index}
                  className={`px-3 py-[10px] rounded-lg  text-center flex justify-center align-center gap-1 cursor-pointer font-Inter ${activeIndex === index
                    ? "!bg-[#ff6933] !text-white"
                    : "!bg-[#f3f4f6]"
                    }`}
                  onClick={() => handleChangeAppointmentDate(item.date, index)}
                >
                  <div className=" text-sm text-gray-700  hover:bg-gray-200">
                    {item.day}
                  </div>
                  <div className="text-sm text-gray-700">{item.date.toLocaleDateString(undefined, {
                    day: "numeric",
                    month: "short"
                  })}</div>
                </button>
              ))}
            </div>

            {/* select time */}
            {
              selectedDate && 
              <div class="col-12 mb-3 mt-4">
               
                  {appointmentData?.length > 0 ? (
                    <>
                     <h2 className="selectDate mb-2">
                  {`${t("Select_time")}`}
                </h2>
                 <div className="grid grid-cols-2 gap-3">
                  {appointmentData.map((item, index) => (
                    <button
                      key={index}
                      className={`px-3 py-[10px] rounded-lg  text-center flex justify-center align-center gap-1 cursor-pointer font-Inter ${activeTime === index
                        ? "!bg-[#ff6933] !text-white"
                        : "!bg-[#f3f4f6]"
                        }`}
                      onClick={() => handleChangeAppointmentTime(item, index)}
                    >
                      <div className=" text-sm text-gray-700  hover:bg-gray-200">
                        {`${item?.startDate} - ${item?.endDate}`}
                      </div>

                    </button>
                  ))}
                </div>
                    </>
               
           
            ):(
              <div className='noSlot'><p>No slots Available</p></div>
            )}
   </div>
            }
          
              

            {/* text */}
            <div className="text">
              <div className="content p-3 mt-4 rounded-lg text-[13px] bg-[#f9fafb] flex align-center gap-2">
                <img src={info} alt="error" className="w-[20px] h-[20px]" />
                <span className="text-gray-600">
                  All appointments are subject to confirmation by the agent.
                </span>
              </div>
            </div>

            {/* buttons */}
            <div className="buttons grid grid-cols-2 gap-2 align-center mt-4">
              <div class="mb-3  w-[100%]">
                <button
                  className="btn contact colorcta rounded-md !text-sm !rounded-md !py-[14px] w-[100%] d-flex justify-center gap-3 align-center font-Inter"
                  style={{
                    backgroundColor: props?.dynamicCtaColor || "#123463",
                    color: props?.dynamicCtaTextColor || "#fff",
                  }}
                  onClick={handleActive}
                >
                  <i class="fa-solid fa-phone"></i>
                  <span>{t("Contact")}</span>
                </button>
              </div>
              <div class="mb-3  w-[100%]">
                <button
                  className="btn colorcta !rounded-md !text-sm !rounded-md !py-[14px] w-[100%] d-flex justify-center gap-3 align-center font-Inter"
                  disabled={!selectedDate || !appointmentTime || appointmentData?.length === 0 || !ext}
                  style={{
                    backgroundColor: props?.dynamicCtaColor || "#ff6a3d",
                    color: props?.dynamicCtaTextColor || "#fff",
                  }}
                  data-bs-toggle="modal"
                  data-bs-target="#appotimnets"
                ><i class="fa-regular fa-calendar"></i>
                  {t("Book Appointment")}
                </button>
              </div>
            </div>
          </div>
        </article>
      </div>
      <div
        class="modal fade"
        ref={createUserRef}
        id="appotimnets"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered" style={{ width: "100%" }}>
          <div class="modal-content">
            <div class="modal-header" style={{ padding: "10px 20px 10px" }}>
              <h5 class="modal-title" id="staticBackdropLabel">
                {t("Make_appointment")}
              </h5>
              <button

                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <form class="row">
                <div class="col-12 mb-3 extmakeappointmentformplaceholder">
                  <input
                    type="text"
                    class="form-control clear_string extmakeappointmentform"
                    placeholder={t("Full_name")}
                    value={appointmentName}
                    onChange={(e) =>
                      setAppointmentName(e.target.value)
                    }
                    style={{ padding: "12px 25px" }}
                  />
                  <div
                    style={{
                      fontSize: "14px",
                      color: "red",

                      bottom: "70px",
                    }}
                  >
                    {errorMsgName}
                  </div>
                </div>
                <div class="col-12 mb-3 extmakeappointmentformplaceholder">
                  <input
                    type="text"
                    class="form-control clear_string extmakeappointmentform"
                    placeholder={t("Email")}
                    value={appointmentEmail}
                    onChange={(e) =>
                      setAppointmentEmail(e.target.value)
                    }
                    style={{ padding: "12px 25px" }}
                  />
                  <div
                    style={{
                      fontSize: "14px",
                      color: "red",
                      bottom: "70px",
                    }}
                  >
                    {errorMsgEmail}
                  </div>
                </div>

                <div class="col-12 mb-3 extmakeappointmentformplaceholder">
                  <PhoneInput
                    name="appointmentContactNumber"
                    value={appointmentContactNumber}
                    country={appointmentCountryCode}
                    countryCodeEditable={false}
                    onChange={(value, country) => {

                      setAppointmentContactNumber(`+${country.dialCode}-${value.substring(
                        country.dialCode.length
                      )}`)
                      setAppointmentCountryCode(country.dialCode)
                    }}

                    className="DetailsInfoPhoneInput DetailsInfoPhoneInputsep"
                  />
                  <div
                    style={{
                      fontSize: "14px",
                      color: "red",

                      bottom: "70px",
                    }}
                  >
                    {errorMsgNo}
                  </div>
                </div>
                <div class="mb-2 mt-2 col-md-12">
                  {isSubmitAppointment ? (
                    <div>
                      <CircularLoader size={20} />
                    </div>
                  ) : (
                    <button
                      onClick={handleSubmit}

                      style={{ background: props?.dynamicCtaColor, color: props?.dynamicCtaTextColor }}
                      class="btn btn-submitform"
                      type="button"
                    >
                      {t("Submit")}
                    </button>
                  )}
                </div>
              </form>
            </div>
            <ToastContainer />
          </div>
        </div>
        
      </div>
    </>

  )
}
